import SubjectSubTable from './SubjectSubTable.container';

export default SubjectSubTable;
